<template>
  <component :is="tag" class="text" :class="modifiers">
    <slot>
      {{ text }}
    </slot>
  </component>
</template>

<script>
export default {
  name: 'BaseText',
  props: {
    tag: {
      type: String,
      default: 'p',
    },
    text: {
      type: String,
      default: '',
    },
    isDim: {
      type: Boolean,
      default: false,
    },
    isDark: {
      type: Boolean,
      default: false,
    },
    isGrey: {
      type: Boolean,
      default: false,
    },
    isBold: {
      type: Boolean,
      default: false,
    },
    isUp: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
    isCenter: {
      type: Boolean,
      default: false,
    },
    isBlock: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modifiers() {
      return {
        text_up: this.isUp,
        text_dim: this.isDim,
        text_dark: this.isDark,
        text_grey: this.isGrey,
        text_bold: this.isBold,
        text_center: this.isCenter,
        text_block: this.isBlock,
        [`text_size_${this.size}`]: Boolean(this.size),
      };
    },
  },
};
</script>

<style lang="stylus">
.text
  display block
  margin 0
  padding 0
  font-size 1em
  line-height typeof( $f_height ) == 'unit' ? $f_height : 1.6

  p
    display block
    margin 0

  b
    color $c_title
    font-weight 600

  p + p
    margin-top 1em

  &_block
    display block
    padding 1em
    background-color $c_bg
    color #000
    border-radius 1em

  &_center
    text-align center

  &_up
    text-transform uppercase

  &_dim
    color $c_dim

  &_dark
    color #000

  &_grey
    color $c_grey

  &_bold
    font-weight 700

  &_size_xxs
    font-size 0.7em

  &_size_xs
    font-size 0.8em

  &_size_s
    font-size 0.9em

  &_size_m
    font-size 1.12em

  &_size_l
    font-size 1.2em

  &_size_xl
    font-size 1.3em

  &_size_xxl
    font-size 1.4em
</style>
